import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import Counter from "./Counter";

class QuantityCounter extends Component {

    handleQuantityChange = (item, action) => {
        if (action === 'add') {
            this.props.quantityChange({id: item.id, value: item.quantity + 1});
        }
        if (action === 'subtract') {
            this.props.quantityChange({id: item.id, value: item.quantity - 1});
        }
    };

    render() {
        return (
            <Counter onAdd={() => this.handleQuantityChange(this.props.item, 'add')}
                     onSubtract={() => this.handleQuantityChange(this.props.item, 'subtract')}>
                {this.props.item.quantity}
            </Counter>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const item = state.getIn(['cart', 'items']).find((product) => {
        return product.get('id') === ownProps.id;
    });
    return {
        item
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        quantityChange: Actions.quantityChange,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(QuantityCounter)`
`));